import { NestedSpeculator } from '@habity/types';
import { SpeculatorsGridView } from './SpeculatorsGridView';
import { Box } from '@chakra-ui/react';

interface SpeculatorsGridProps {
  speculators?: NestedSpeculator[] | null;
  loading: boolean;
  hasMore: boolean;
}

export function SpeculatorsGrid({
  speculators,
  loading,
  hasMore,
}: SpeculatorsGridProps) {
  return (
    <Box>
      <SpeculatorsGridView
        speculators={speculators}
        loading={loading}
        hasMore={hasMore}
      />
    </Box>
  );
};
